import { ModalToolbar } from '@/components/Modal';
import { NomenclatureModalDeleteButton, NomenclatureModalDuplicateButton } from '@/components/nomenclature/actions';

// ----------------------------------------------------------------------

type NomenclatureModalToolbarProps = {
  // eslint-disable-next-line react/boolean-prop-naming
  disabled?: boolean;
};

export const NomenclatureModalToolbar = (props: NomenclatureModalToolbarProps) => {
  const { disabled } = props;

  return (
    <ModalToolbar>
      <NomenclatureModalDuplicateButton disabled={disabled} />
      <NomenclatureModalDeleteButton disabled={disabled} />
    </ModalToolbar>
  );
};
